import { render, staticRenderFns } from "./TaskStatusIcon.vue?vue&type=template&id=0fc265e7&scoped=true"
import script from "./TaskStatusIcon.vue?vue&type=script&lang=ts"
export * from "./TaskStatusIcon.vue?vue&type=script&lang=ts"
import style0 from "./TaskStatusIcon.vue?vue&type=style&index=0&id=0fc265e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc265e7",
  null
  
)

export default component.exports